import { render, staticRenderFns } from "./FeedFormula.vue?vue&type=template&id=2fca574f&scoped=true"
import script from "./FeedFormula.vue?vue&type=script&lang=js"
export * from "./FeedFormula.vue?vue&type=script&lang=js"
import style0 from "./FeedFormula.vue?vue&type=style&index=0&id=2fca574f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca574f",
  null
  
)

export default component.exports